<template>


	<div style="display: inline-block;width: 640px;" v-if="video && video.poster && video.tank">
		<video ref="video" class="video-js vjs-default-skin"
		       controls preload="auto" width="640" height="480"
		       :poster="video.poster.url"
		       data-setup='{}'>
			<source :src="video.tank.url" :type="video.tank.type"/>
			<p class="vjs-no-js">
				您的浏览器不支持Html5的视频播放，请使用
				<a href="http://sw.bos.baidu.com/sw-search-sp/software/13d93a08a2990/ChromeStandalone_55.0.2883.87_Setup.exe">
					Chrome
				</a>
				浏览器以达到最佳体验。
			</p>
		</video>

	</div>

</template>


<script>

	import {startWith, endWith, getPureExtension, containStr} from '../../common/filter/str'
	import Video from '../../common/model/video/Video'

	import videojs from "video.js";
	//import SWF_PATH from 'file!video.js/dist/video-js.swf';
	//import VTTJS_PATH from 'file!videojs-vtt.js/dist/vtt.min.js';
	let SWF_PATH = require("file-loader!video.js/dist/video-js.swf");
	let VTTJS_PATH = require("file-loader!videojs-vtt.js/dist/vtt.min.js");
	require('imports-loader?videojs=video.js!video.js/dist/lang/zh-CN');

	videojs.options.flash.swf = SWF_PATH;
	videojs.options['vtt.js'] = VTTJS_PATH;

	export default {

		props: {
			video: {
				type: Video,
				required: true,
				"default": ""
			}
		},
		watch: {
			"video.tank.url"(newVal, oldVal){

				console.log("检测到video.tank变化了");
				console.log(newVal);

				if (newVal) {
					this.refresh();
				}


			}
		},
		computed: {},
		methods: {
			refresh(){
				videojs(this.$refs.video, {}, function () {
					// Player (this) is initialized and ready.
				});
			}
		},
		mounted(){

			console.log("mounted video");
			this.refresh();
		}
	};
</script>


<style lang="less" rel="stylesheet/less">

	.video-js {

	}
</style>



// WEBPACK FOOTER //
// NbVideo.vue?e21ebb82